var swiper = new Swiper(".release-slider", {
    slidesPerView: 1,
    spaceBetween: 40,
    loop: true,
    centeredSlides: false, 
    speed: 600,
    pagination: {
        el: ".release-slider .my-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".release-slider .swiper-button-next",
        prevEl: ".release-slider .swiper-button-prev",
    },
    breakpoints: { 
        640: {
            slidesPerView: 1,
            spaceBetween: 20
        }, 
        768: {
            slidesPerView: 2,
            spaceBetween: 30
        }, 
        1200: {
            slidesPerView: 3.7,
            spaceBetween: 40
        },
        1560: {
            slidesPerView: 3.7,
            spaceBetween: 40
        }, 
    }
});





const headers = document.querySelectorAll('.accordion-header');

headers.forEach(header => {
    header.addEventListener('click', () => {
        const body = header.nextElementSibling;
        const isOpen = body.classList.contains('open');

        // Close all
        document.querySelectorAll('.accordion-body').forEach(b => {
            b.classList.remove('open');
            b.style.maxHeight = null;
            b.style.padding = '0 20px'; // Reset padding when closing
        });

        document.querySelectorAll('.accordion-header').forEach(h => {
            h.classList.remove('active');
        });

        // Open selected
        if (!isOpen) {
            body.classList.add('open');
            body.style.maxHeight = (body.scrollHeight + 40) + 'px';
            body.style.padding = '20px';
            header.classList.add('active');

            // Scrol0l to opened accordion with 2 second delay
            setTimeout(() => {
                // Get the exact position of the accordion header
                const headerRect = header.getBoundingClientRect();
                const headerTop = headerRect.top + window.pageYOffset;
                const offset = 100; // Adjust this value based on your fixed header height

                // Scroll to the accordion header with offset
                window.scrollTo({
                    top: headerTop - offset,
                    behavior: 'smooth'
                });
            }, 300); // 1 second delay as requested
        }
    });
});


// 


const buttons = document.querySelectorAll('.tab-button');
const contents = document.querySelectorAll('.tab-content');

buttons.forEach(button => {
    button.addEventListener('click', () => {
        buttons.forEach(btn => btn.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));

        button.classList.add('active');
        document.getElementById(button.getAttribute('data-tab')).classList.add('active');
    });
});




var swiper = new Swiper(".vrSwiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    // direction: "vertical",
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});



var swiper = new Swiper(".acSwiper", {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    centeredSlides: true,
    // 👈 This line centers the active slide
    breakpoints: {
        1024: {
            slidesPerView: 3,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        320: {
            slidesPerView: 1,
            spaceBetween: 20
        },
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});




var swiper = new Swiper(".fmhSwiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    // direction: "vertical",
    centeredSlides: false,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});




// // Initialize Swiper
// var swiper = new Swiper(".tabSwiper", {
//     slidesPerView: 1,
//     spaceBetween: 30,
//     loop: false,
//     pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//     },
//     on: {
//         slideChange: function () {
//             // Update navigation tabs when slide changes
//             updateNavigationTabs(this.activeIndex);
//         }
//     }
// });

// // Get navigation tabs
// const navTabs = document.querySelectorAll('.nav-tab');

// // Add click event to navigation tabs
// navTabs.forEach((tab, index) => {
//     tab.addEventListener('click', () => {
//         // Update swiper to the clicked slide
//         swiper.slideTo(index);

//         // Update active tab
//         updateNavigationTabs(index);
//     });
// });

// // Function to update navigation tabs
// function updateNavigationTabs(activeIndex) {
//     navTabs.forEach((tab, index) => {
//         if (index === activeIndex) {
//             tab.classList.add('active');
//         } else {
//             tab.classList.remove('active');
//         }
//     });
// }



function initTabSwiper() {
  const swiperEl = document.querySelector('.tabSwiper');
  const navTabs = document.querySelectorAll('.nav-tab');

  if (!swiperEl || !navTabs.length || typeof Swiper === 'undefined') return;

  // Avoid double init
  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    autoHeight: true,
    pagination: {
      el: swiperEl.querySelector('.swiper-pagination') || '.swiper-pagination',
      clickable: true,
    },
    on: {
      init: function () {
        updateNavigationTabs(this.activeIndex);
      },
      slideChange: function () {
        updateNavigationTabs(this.activeIndex);
      }
    }
  });

  navTabs.forEach((tab, index) => {
    tab.addEventListener('click', function (e) {
      e.preventDefault();

      swiper.slideTo(index);
      updateNavigationTabs(index);
    });
  });

  function updateNavigationTabs(activeIndex) {
    navTabs.forEach((tab, index) => {
      tab.classList.toggle('active', index === activeIndex);
    });
  }
}

// Normal page load
document.addEventListener('DOMContentLoaded', initTabSwiper);

// Shopify theme editor / section reload support
document.addEventListener('shopify:section:load', initTabSwiper);






const video = document.getElementById('customVideo');
const overlay = document.getElementById('playOverlay');
if (video) {
    document.getElementById('videoBox').addEventListener('click', () => {
        if (video.paused) {
            video.play();
            overlay.style.display = 'none';
        } else {
            video.pause();
            overlay.style.display = 'flex';
        }
    });
}


document.querySelectorAll('.videoBox').forEach(customBox => {
    const localVideo = customBox.querySelector('video');
    const localOverlay = customBox.querySelector('.playOverlay');

    customBox.addEventListener('click', () => {
        if (localVideo.paused) {
            localVideo.play();
            localOverlay.style.display = 'none';
        } else {
            localVideo.pause();
            localOverlay.style.display = 'flex';
        }
    });
});




var swiper = new Swiper(".imgSwiper", {
    slidesPerView: 11,
    spaceBetween: 0,
    breakpoints: {
        1024: {
            slidesPerView: 8,
            spaceBetween: 0
        },
        768: {
            slidesPerView: 6,
            spaceBetween: 0
        },
        320: {
            slidesPerView: 4,
            spaceBetween: 0
        },
    },
    // slidesPerView: "auto",
    // spaceBetween: 20,
    loop: true,
    speed: 600,
    autoplay: {
        delay: 1000,
        disableOnInteraction: false,
    },
    centeredSlides: true, // 👈 This line centers the active slide
});



var sliderThumbnail = new Swiper('.slider-thumbnail', {
    direction: "vertical",
    // slidesPerView: 3,
    initialSlide: 1,
    slidesPerView: "auto",
    spaceBetween: 10,
    centeredSlides: "true",
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: false,
    allowTouchMove: false,
});

var mirrorSlider = new Swiper('.mirror-slider', {
    effect: "fade",
    thumbs: {
        swiper: sliderThumbnail
    }
});





const accSingleTriggers = document.querySelectorAll('.js-acc-single-trigger');

accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

function toggleAccordion() {
    const items = document.querySelectorAll('.js-acc-item');
    const thisItem = this.parentNode;

    items.forEach(item => {
        if (thisItem == item) {
            thisItem.classList.toggle('is-open');
            return;
        }
        item.classList.remove('is-open');
    });
} 

const readMoreBtn1 = document.getElementById("read-more-btn-1");
const readMoreBtn2 = document.getElementById("read-more-btn-2");

if (readMoreBtn1) {
    readMoreBtn1.addEventListener("click", function () {
        const moreText = document.getElementById("more-txt-1");
        if (moreText.style.display === "none" || moreText.style.display === "") {
            moreText.style.display = "inline";
            this.textContent = "Read Less";
        } else {
            moreText.style.display = "none";
            this.textContent = "Read More";
        }
    });
}

if (readMoreBtn2) {
    readMoreBtn2.addEventListener("click", function () {
        const moreText2 = document.getElementById("more-txt-2");
        if (moreText2.style.display === "none" || moreText2.style.display === "") {
            moreText2.style.display = "inline";
            this.textContent = "Read Less";
        } else {
            moreText2.style.display = "none";
            this.textContent = "Read More";
        }
    });
}

document.querySelectorAll(".read-more-btn").forEach(function(btn) {
    btn.addEventListener("click", function() {
        const sectionId = this.id.replace("read-more-btn-", "");
        const moreText = document.getElementById("more-txt-" + sectionId);

        if (moreText.style.display === "none" || moreText.style.display === "") {
            moreText.style.display = "block";
            this.textContent = "Read Less";
        } else {
            moreText.style.display = "none";
            this.textContent = "Read More";
        }
    });
});



function playInlineVideo() {
    let video = document.getElementById("videoPlayer");
    let thumb = document.getElementById("thumb");
    let overlay = document.getElementById("overlayContent");

    // Fade out overlay + thumbnail
    thumb.classList.remove("show");
    overlay.classList.remove("show");

    setTimeout(() => {
        thumb.style.display = "none";
        overlay.style.display = "none";

        // Show and fade in video
        video.style.display = "block";
        video.classList.add("show");
        video.play();
    }, 600); // wait until fade-out is complete
}






// const productList = document.getElementById("productList");

// function addRow() {
//     const index = productList.children.length;
//     const newRow = document.createElement("div");
//     newRow.classList.add("product-row");
//     newRow.innerHTML = `
//     <input type="text" name="products[${index}][catalog]" placeholder="B1234">
//     <input type="text" name="products[${index}][name]" placeholder="B1234">
//     <input type="number" name="products[${index}][quantity]" placeholder="120">
//     <div class="actions">
//       <button type="button" class="btn delete">
//         <img src="https://cdn.shopify.com/s/files/1/0686/3660/6704/files/delete.svg?v=1756110741" alt="">
//       </button>
//       <button type="button" class="btn add">
//         <img src="https://cdn.shopify.com/s/files/1/0686/3660/6704/files/add.svg" alt="">
//       </button>
//     </div>
//   `;
//     productList.appendChild(newRow);
// }

// productList.addEventListener("click", (e) => {
//     if (e.target.classList.contains("add")) {
//         addRow();
//     } else if (e.target.classList.contains("delete")) {
//         const row = e.target.closest(".product-row");
//         if (productList.children.length > 1) {
//             row.remove();
//         } else {
//             alert("At least one row is required!");
//         }
//     }
// });





function addRow(list) {
  const index = list.querySelectorAll(".product-row").length;
  const newRow = document.createElement("div");
  newRow.classList.add("product-row");
  newRow.innerHTML = `
  <div class="field-col">
    <label>Catalog No.</label>
    <input type="text" name="contact[products][${index}][catalog]" placeholder="e.g. B1234">
  </div>
  <div class="field-col">
    <label>Product Name</label>
    <input type="text" class="input-pr-name" name="contact[products][${index}][name]" placeholder="Product Name Here">
  </div>
  <div class="field-col quantity-col">
    <div class="label-col">
    <label>Quantity</label>
    <input type="number" name="contact[products][${index}][quantity]" placeholder="0">
    </div>
    <button type="button" class="btn delete">
      <img src="https://cdn.shopify.com/s/files/1/0686/3660/6704/files/delete-01.svg" alt="">
    </button>
    <button type="button" class="btn add">
      <img src="https://cdn.shopify.com/s/files/1/0686/3660/6704/files/add-01.svg" alt="">
    </button>
  </div>
    
  `;
  list.appendChild(newRow);
}

const errPopup = document.querySelector("#customErrorPopup");
if (errPopup) {
    const errPopupClose = errPopup.querySelector("#customErrorBtn");
    // Attach events to ALL product-lists
    document.querySelectorAll(".product-list").forEach((list) => {
    list.addEventListener("click", (e) => {
        if (e.target.closest(".add")) {
        addRow(list);
        } else if (e.target.closest(".delete")) {
        const row = e.target.closest(".product-row");
        if (list.querySelectorAll(".product-row").length > 1) {
            row.remove();
        } else {
            // alert("At least one row is required!");
            errPopup.classList.add("active")
        }
        }
    });
    });

    errPopupClose.addEventListener("click", ()=>{
        errPopup.classList.remove("active")
    }); 
}



const timeline = document.querySelector(".mission-tl");
const items = document.querySelectorAll(".mission-tl li");
if(timeline){
    const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        // Animate forward
        timeline.classList.add("active");
        items.forEach((item, i) => {
            setTimeout(() => item.classList.add("active"), i * 500);
        });
        } else {
        // Animate reverse
        timeline.classList.remove("active");
        items.forEach(item => item.classList.remove("active"));
        }
    });
    }, { threshold: 0.3 });

    observer.observe(timeline);
}


// 



document.addEventListener('click', function (e) {
  const summary = e.target.closest('.menu-drawer details > summary[data-url]');
  if (!summary) return;

  const details = summary.closest('details');
  const url = summary.dataset.url;
  const arrowClicked = e.target.closest('.drawer-menu-arrow');

  e.preventDefault();
  e.stopPropagation();

  if (arrowClicked) {
    details.open = !details.open;
  } else if (url && url !== '#') {
    window.location.href = url;
  }
});

// 


document.addEventListener("DOMContentLoaded", function () {

  // Sirf wo paragraph lo jisme actual text ho
  const paragraphs = document.querySelectorAll(".product-details-box .pr-disc-box p");

  let desc;

  paragraphs.forEach(p => {
    if(p.innerText.trim().length > 20){
      desc = p;
    }
  });

  if(desc){

    // Read More Button Create
    const btn = document.createElement("button");
    btn.classList.add("read-more-btn");
    btn.innerText = "Read More";

    // Paragraph ke baad button add karo
    desc.insertAdjacentElement("afterend", btn);

    btn.addEventListener("click", function () {

      desc.classList.toggle("expanded");

      if(desc.classList.contains("expanded")){
        btn.innerText = "Read Less";
      } else {
        btn.innerText = "Read More";
      }

    });

  }

});






document.addEventListener("DOMContentLoaded", function () {
  const productGallery = document.querySelector("media-gallery");

  // Stop JS if product gallery does not exist
  if (!productGallery) return;

  const mediaItems = productGallery.querySelectorAll(".product__media");

  if (!mediaItems.length) return;

  mediaItems.forEach((media) => {
    const image = media.querySelector("img.image-magnify-hover");

    if (!image) return;

    media.addEventListener("mouseenter", function () {
      media.classList.add("is-zooming");
    });

    media.addEventListener("mousemove", function (e) {
      const rect = media.getBoundingClientRect();

      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      image.style.transformOrigin = `${x}% ${y}%`;
    });

    media.addEventListener("mouseleave", function () {
      media.classList.remove("is-zooming");
      image.style.transformOrigin = "center center";
    });
  });
});